import * as actions from '../actions/broker';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenSequentially from "xstream/extra/flattenSequentially";
import {unlockBrokerFailed, unlockBrokerSuccess} from "../actions/broker";

export function requestUpdateBrokerPassword(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UPDATE_BROKER_PASSWORD)
        .map(action => ({
            url: BASE_URL + 'api/users/Brokers/' + action.payload.sendBody.userId,
            category: 'requestUpdateBrokerPassword',
            method: 'PATCH',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateBrokerPassword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status === 200)
        .map(response => actions.updateBrokerPasswordSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateBrokerPasswordFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateBrokerPassword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status !==200)
        .map(response => actions.updateBrokerPasswordFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestUpdateBrokerById(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UPDATE_BROKER_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/users/Brokers/' + action.payload.sendBody.userId,
            category: 'requestUpdateBrokerById',
            method: 'PATCH',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateBrokerById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status === 200)
        .map(response => actions.updateBrokerByIdSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateBrokerByIdFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateBrokerById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status !==200)
        .map(response => actions.updateBrokerByIdFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestBrokerById(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_BROKER_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/users/Brokers/' + action.payload.id,
            category: 'requestBrokerById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestBrokerById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getBrokerByIdSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestBrokerByIdFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestBrokerById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getBrokerByIdFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestCreateBroker(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.CREATE_BROKER)
        .map(action => ({
            url: BASE_URL + 'api/users/Brokers',
            category: 'requestCreateBroker',
            method: 'POST',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestCreateBroker')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.createBrokerSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestCreateBrokerFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestCreateBroker')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 201)
        .map(response => actions.createBrokerFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestUnlockBrokerUser(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UNLOCK_BROKER)
        .map(action => ({
            url: BASE_URL + `api/users/brokers/${action.payload.brokerId}/unlock`,
            category: 'requestUnlockBrokerUser',
            method: 'PATCH',
            type: 'application/json',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the posted new solicitors
    let httpResponse$ = sources.HTTP
        .select('requestUnlockBrokerUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.unlockBrokerSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function requestUnlockBrokerUserFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUnlockBrokerUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200 )
        .map(response => actions.unlockBrokerFailed(response));

    return {
        ACTION: httpResponse$
    }
}